import { ChangeEvent } from 'react';

import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';
import { CloseButton } from 'UIPackage/MainModule/components/CloseButton';

import styles from './TemplatesItem.module.scss';

interface ITemplatesItemProps {
  id: string | number;
  name: string;
  groupName: string;
  isChecked?: boolean;
  isActive?: boolean;
  onCheckboxChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
  onDelete?: () => void;
}

export const TemplatesItem = ({
  id,
  name,
  groupName,
  isChecked = false,
  isActive = false,
  onCheckboxChange,
  onClick,
  onDelete,
}: ITemplatesItemProps) => {
  const tabItemAttributes = {
    ...(isActive && { 'data-active': true }),
  };

  return (
    <div className={styles.Block} {...tabItemAttributes}>
      <button className={styles.SelectButton} type="button" onClick={onClick} />
      <div className={styles.Content}>
        <Checkbox
          className={styles.Checkbox}
          id={id.toString()}
          name={groupName}
          type="radio"
          theme="system"
          size="medium"
          checked={isChecked}
          onChange={onCheckboxChange}
        />
        <div className={styles.Title}>{name}</div>
      </div>
      {onDelete && <CloseButton className={styles.DeleteButton} onClick={onDelete} />}
    </div>
  );
};
